module.exports = __webpack_public_path__ + "images/0aa4bcfd41578c8525b4ac1fb8d609cf-lock_illustration.svg";